<template>
	<div>
		<modalconfirm ref="modalCreateSDO" @action="buatSDO"/>

		<ModalAddSerial ref="ModalAddSerial" :type="serial_type" :name="product_name" :quantity="quantity" @saveSerial="saveSerial"/>

		<div class="text-h5">Tambah Sales Delivery Order</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form ref="formAddSDO">
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-autocomplete item-value="so_code" v-model="so_code" :items="listSOProccess" label="Sales Order" outlined dense class="width-0" :rules="[inputrules.required]" no-data-text="Tidak ada data yang sesuai" :filter="customFilter">
										<template v-slot:item = {item}>
											{{item.so_code}} - {{item.customer_network_code}} - {{item.customer_name}}
										</template>
										<template v-slot:selection = {item}>
											{{item.so_code}}
										</template>
									</v-autocomplete>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="d-flex justify-start align-center py-0" v-if="detailSO.customer_can_upgrade == true">
									<v-checkbox v-model="upgrade" label="Upgrade Ke MB" class="mt-1"></v-checkbox>
								</v-col>
								<v-col cols="12" sm="6" md="6" class="d-flex justify-start align-center py-0" v-if="detailSO.customer_get_free_tools == true && (upgrade == true || detailSO.customer_level == 'mb')">
									<v-checkbox v-model="free_tools" :disabled="detailSO.free_tools.result == false" label="Free Tools" class="mt-1"></v-checkbox>
									<span class="text--pink" v-if="detailSO.free_tools.result == false">{{detailSO.free_tools.message}}</span>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-row>
								<v-col cols="12" class="py-0">
									<v-menu v-model="menuDateSent" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="convertDate(est_sent)" label="Estimasi Pengiriman" :error-messages="responseError.estimated_sent_date"  @focus="responseError.estimated_sent_date = ''" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense :rules="[inputrules.required]"></v-text-field>
										</template>
										<v-date-picker locale="id" @input="menuDateSent = false" color="primary" v-model="est_sent"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" class="pb-0">
									<v-menu v-model="menuDateReceived" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on, attrs }">
											<v-text-field :value="convertDate(est_received)" label="Estimasi Penerimaan" :error-messages="responseError.estimated_received_date" @focus="responseError.estimated_received_date = ''" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined dense :rules="[inputrules.required]" hide-details="auto"></v-text-field>
										</template>
										<v-date-picker locale="id" @input="menuDateReceived = false" color="primary" v-model="est_received"></v-date-picker>
									</v-menu>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-textarea v-model="note" label="Catatan" :error-messages="responseError.note" hide-details="auto" outlined dense height="119" no-resize></v-textarea>
						</v-col>
						<v-col cols="12">
							<v-data-table disable-pagination :headers="headers" :items="detailSO.so_detail" hide-default-footer no-data-text="Tidak ada data tersedia" class="white-row custom-table table-w-130">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.so_detail_product_name }}</div>
								</template>
								<template v-slot:item.product_code="{ item }">
									<div class="pt-2">{{ item.so_detail_product_code }}</div>
								</template>
								<template v-slot:item.product_unit="{ item }">
									<div class="pt-2">{{ item.so_detail_product_unit }}</div>
								</template>
								<template v-slot:item.product_batch_code="{ item }">
									<v-text-field class="py-3" v-model="item.product_batch_code" outlined dense hide-details="auto" background-color="white"></v-text-field>
								</template>
								<template v-slot:item.price="{ item }">
									<div class="pt-2">{{ item.so_detail_product_price | toNumber }}</div>
								</template>
								<template v-slot:item.quantity="{ item }">
									<div class="pt-2">{{ item.so_detail_quantity_sold | toNumber }}</div>
								</template>
								<template v-slot:item.quantity_sent="{ item }">
									<v-currency-field class="py-3" v-model="item.so_detail_quantity_remaining" :rules="[inputrules.required]" outlined dense hide-details="auto" background-color="white"></v-currency-field>
								</template>
								<template v-slot:item.card_type="{ item }">
									<v-radio-group v-model="item.card_type" row v-if="item.so_detail_product_is_serial" @change="item.serial = []" :disabled="detailSO.customer_trx_method != 'system'">
										<v-radio label="Fisik" value="fisik"></v-radio>
										<v-radio label="Digital" value="digital"></v-radio>
									</v-radio-group>
								</template>
								<template v-slot:item.is_serial="{ item }">
									<v-tooltip bottom v-if="item.so_detail_product_is_serial && item.so_detail_quantity_remaining > 0 && item.card_type == 'fisik'">
										<template v-slot:activator="{ on, attrs }">
											<v-btn @click="showModalSerial(item)" fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on">
												<v-icon dark>mdi-plus</v-icon>
											</v-btn>
										</template>
										<span v-if="!item.card_type">Silahkan Pilih Tipe Serial</span>
										<span v-else>Tambah Serial</span>
									</v-tooltip>
								</template>
							</v-data-table>
						</v-col>
						<v-col cols="12" v-if="free_tools == true">
							<div class="text-subtitle-2 font-weight-bold">Data Free Tools</div>
							<v-simple-table class="white-row pt-3">
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="15%" class="text-left">Kode Produk</th>
											<th width="15%" class="text-center">Jumlah</th>
											<th width="30%"></th>
										</tr>
									</thead>
									<tbody v-if="detailSO.so_detail">
										<tr v-for="(product, index) in OptionFreeTools" :key="index">
											<td> {{ product.product_name }} </td>
											<td> {{ product.product_code }} </td>
											<td class="text-center"> {{ product.quantity | toNumber }} </td>
											<td></td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" :disabled="!so_code" depressed @click="confirmCreate" class="text-capitalize">
					<div>Proses</div>
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import ModalAddSerial from '@/views/MLwarehouse/sdo/ModalAddSerial'

export default {
	inject: ['theme'],
	components: {
		ModalAddSerial
	},
	data() {
		return {
			menuDateSent: false,
			menuDateReceived: false,
			so_code: '',
			est_sent: '',
			est_received: '',
			note: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', width: "8%", sortable: false},
			{ text: 'Satuan', value: 'product_unit', width: "10%", sortable: false},
			{ text: 'Kode Batch', value: 'product_batch_code', width: "15%", sortable: false},
			{ text: 'Harga (Rp)', value: 'price', width: "10%", align: 'end'},
			{ text: 'Jumlah', value: 'quantity', width: "10%", align: 'center'},
			{ text: 'Jumlah Kirim', value: 'quantity_sent', width: "10%"},
			{ text: 'Tipe Serial', value: 'card_type', width: "10%"},
			{ text: 'Serial', value: 'is_serial', width: "8%"},
			],
			serial_type: [],
			card_type: '',
			product_name: '',
      quantity: 0,
			product_id: '',
			free_tools: false,
			upgrade: false,
		}
	},
	computed: {
		...mapState('so', ['detailSO']),
		...mapGetters('so', ['productSO']),
		...mapState('sdo', ['listSOProccess', 'response', 'responseError', 'alertMultiple', 'OptionFreeTools']),
	},
	methods: {
		...mapActions('so', ['getDetailSO']),
		...mapMutations('so', ['setDetailSO', 'clearDataSO']),
		...mapActions('sdo', ['getSOApproved', 'createSDO', 'scanSerial', 'getOptionFreeTools']),
		...mapMutations('sdo', ['saveResponse', 'clearDataSDO']),
		...mapMutations(['setSnackbar', 'setOverlay']),

		showModalSerial(item) {
			if (item.card_type) {
				this.serial_type = item.so_detail_product_is_serial

				this.card_type = item.card_type
				this.product_id = item.so_detail_product_id
				this.quantity = item.so_detail_quantity_remaining
				this.product_name = item.so_detail_product_name
				this.$refs.ModalAddSerial.showModal()
				// this.$refs.ModalAddSerial.updateSerial(item.serial)
			}
		},
		async saveSerial(serial_data) {
      // define index product
			let indexProduct = await this.detailSO.so_detail.findIndex(el => el.so_detail_product_id == this.product_id);

      let serialArray = []
			await this.detailSO.so_detail.forEach( el => {
		
		if (el.so_detail_product_is_serial != null) {
			el.so_detail_product_is_serial.forEach(serial => {
				if (serial.type_id == serial_data.type_id) {
					serialArray = [... serialArray, ... serial.serial_array]
				}
			})
		}
			});

			await this.scanSerial({
				serial: serial_data.serial,
				type: serial_data.type_id,
				card_type: this.card_type
			}).then((serial) => {
        let serialSuccess = serial.success.filter(el => {
          return !serialArray.includes(el)
        })
        // set product based on index
				let product = this.detailSO.so_detail[indexProduct]

        // find index serial
        let indexSerial = product.so_detail_product_is_serial.findIndex(el => {
          return el.type_id == serial_data.type_id
        });

        // define dataSerial by index serial
        let dataSerial = product.so_detail_product_is_serial[indexSerial]

        // set total serial needed
        let serial_needed = product.so_detail_quantity_remaining * serial_data.quantity

        // define serial to save
				let unique = new Set([... dataSerial.serial_array, ... serialSuccess])
				if (serial_needed >= (dataSerial.serial_array.length + serialSuccess.length)) {
					dataSerial.serial_array = [... unique]
					this.detailSO.so_detail[indexProduct].so_detail_product_is_serial[indexSerial].serial_array = dataSerial.serial_array
					this.setSnackbar({
						show: true,
						color: 'success',
						text: `Berhasil scan serial`
					})
				} else {
					if (serialSuccess.length > 0) {
						dataSerial.serial_array = [... unique]
						this.detailSO.so_detail[indexProduct].so_detail_product_is_serial[indexSerial].serial_array = dataSerial.serial_array.slice(0, serial_needed)
						this.setSnackbar({
							show: true,
							color: 'red darken-2',
							text: `Jumlah serial yang diproses disesuaikan`
						})
					} else {
						this.setSnackbar({
							show: true,
							color: 'red darken-2',
							text: 'Gagal scan serial'
						})
					}
				}

				var alert = []
				for (let variable in serial.failed) {
					var msg = '';
					msg += serial.failed[variable].join(', ')
					msg += ` ${variable}`
					alert.push({
						msg: msg,
						show: true
					})
				}
				this.$refs.ModalAddSerial.showMessage(alert)
			}).catch((serial) => {
				var alert = []
				for (let variable in serial.failed) {
					var msg = '';
					msg += serial.failed[variable].join(', ')
					msg += ` ${variable}`
					alert.push({
						msg: msg,
						show: true
					})
				}
				this.$refs.ModalAddSerial.showMessage(alert)
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: 'Gagal scan serial'
				})
			})
		},
		customFilter (item, queryText) {
			const textOne = item.so_code.toLowerCase()
			const textTwo = item.customer_network_code.toLowerCase()
			const textThree = item.customer_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1 || textThree.indexOf(searchText) > -1
		},
		confirmCreate(){
			if (this.$refs.formAddSDO.validate()) {
				let msg = "Yakin akan memproses pengiriman ini?"
				this.$refs.modalCreateSDO.setMessage(msg)
				this.$refs.modalCreateSDO.showConfirm()
			}
		},
		async buatSDO() {
			await this.setOverlay(true)
			await this.$refs.modalCreateSDO.hideConfirm()
			let params = await {
				so_id: this.detailSO.so_id,
				estimated_sent_date: this.est_sent,
				estimated_received_date: this.est_received,
				note: this.note,
				product: this.productSO,
				upgrade: this.upgrade,
				free_tools: this.free_tools
			}
			
			await this.createSDO(params).then(() => {
				if (this.response.code == 200.) {
					this.so_code = ''
					this.est_sent = ''
					this.est_received = ''
					this.note = ''
					this.setDetailSO('')
					this.$refs.formAddSDO.resetValidation()
					this.getSOApproved()
					this.saveResponse({})
				}
			})
			
			await this.setOverlay(false)
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah Sales Delivery`)
		this.getOptionFreeTools()
		this.getSOApproved()
	},
	beforeDestroy(){
		this.clearDataSDO()
		this.clearDataSO()
	},
	watch: {
		so_code(val) {
			if (val) {
				this.getDetailSO(val)
			} else {
				this.setDetailSO('')
			}
			this.free_tools = false
			this.upgrade = false
		}
	}
}
</script>
